import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form';

import * as Styled from './MobilePhoneNumberInput.styled';
import { Label } from '../../../../../Toolkit/Inputs/Label';
import { ErrorMessage } from '../../../../../Toolkit/Inputs/ErrorMessage';
import { Select } from '../../../../../Toolkit/Inputs/Select';
import { FinanceTextField } from '../../../../financeProviders/shared/FinanceTextField/FinanceTextField';

type Props<T extends FieldValues> = {
  fieldName: Path<T>;
  label: string;
  placeholder?: string;
  options: Array<string>;
  phoneExtensionName: string;
  isExtensionDisabled: boolean;
};

const MobilePhoneNumberInput = <T extends FieldValues>(props: Props<T>) => {
  const {
    fieldName,
    label,
    placeholder,
    options,
    phoneExtensionName,
    isExtensionDisabled,
  } = props;

  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field, fieldState }) => (
        <div>
          <Label htmlFor={fieldName}>{label}</Label>
          <Styled.InputContainer>
            <Select
              options={options}
              name={phoneExtensionName}
              disabled={isExtensionDisabled}
              placeholder={false}
              placeholderAsOption
              willUseSubText={false}
            />
            <FinanceTextField
              {...field}
              {...fieldState}
              type="tel"
              marginBottom="S4"
              placeholder={placeholder}
              willUseSubText={false}
            />
          </Styled.InputContainer>
          {fieldState.error?.message && (
            <ErrorMessage text={fieldState.error.message} />
          )}
        </div>
      )}
    />
  );
};

export { MobilePhoneNumberInput };
